export default __webpack_public_path__ + "static/media/PandavaraGudda.3b380a33.jpg";